import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=b03f07ae&scoped=true&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"
import style0 from "./Video.vue?vue&type=style&index=0&id=b03f07ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03f07ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b03f07ae')) {
      api.createRecord('b03f07ae', component.options)
    } else {
      api.reload('b03f07ae', component.options)
    }
    module.hot.accept("./Video.vue?vue&type=template&id=b03f07ae&scoped=true&", function () {
      api.rerender('b03f07ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/components/products/preview/Video.vue"
export default component.exports